import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Icon,
  Button,
  Box,
  IconButton,
  Card,
  Text,
  Title,
  Spinner,
} from '@nimbus-ds/components';
import { Layout, Page } from '@nimbus-ds/patterns';
import { CogIcon } from '@nimbus-ds/icons';
import tokens from '@nimbus-ds/tokens/dist/js/tokens';
import { navigateHeaderRemove } from '@tiendanube/nexo/helpers';

import nexo from '../../nexoClient';
import { useWindowWidth } from '../../hooks';

import axiosInstance from '../../axios';

const PageDashboard: React.FC = () => {
  const { push } = useHistory();
  const windowWidth = useWindowWidth();
  const breakpointMd = tokens.breakpoint.md.value.replace('px', '');

  const [activeAuctions, setActiveAuctions] = useState<any[]>([]);
  const [loadingAuctions, setLoadingAuctions] = useState(false);

  const handleGoToConfig = () => push('/config');
  const handleGoToSellersView = () => push('/setup');
  const handleGoToLogs = () => push('/logs');

  const actions =
    windowWidth !== null && windowWidth <= breakpointMd ? (
      <IconButton
        backgroundColor="transparent"
        borderColor="transparent"
        onClick={handleGoToConfig}
        source={<CogIcon />}
        size="2rem"
      />
    ) : (
      <Box display="flex" gap="4">
        <Button onClick={handleGoToSellersView}>
          <Icon source={<CogIcon />} color="currentColor" />
          Clientes
        </Button>
        <Button appearance="primary" onClick={handleGoToConfig}>
          <Icon source={<CogIcon />} color="currentColor" />
          Subastas
        </Button>
        <Button appearance="primary" onClick={handleGoToLogs}>
          <Icon source={<CogIcon />} color="currentColor" />
          Registros
        </Button>
      </Box>
    );

  useEffect(() => {
    navigateHeaderRemove(nexo);
    getActiveAuctions();
  }, []);

  const getActiveAuctions = async () => {
    setLoadingAuctions(true);
    try {
      const response = await axiosInstance.get('/active_auctions');
      if (response.data.status === 'SUCCESS') {
        setActiveAuctions(response.data.auctions);
      }
    } catch (error) {
      console.error('Error fetching active auctions:', error);
    } finally {
      setLoadingAuctions(false);
    }
  };

  return (
    <Page maxWidth="1000px">
      <Page.Header title="" buttonStack={actions} />
      <Page.Body>
        <Layout columns="1">
          <Layout.Section>
            <Card>
              <Card.Header title="Bienvenido/a" />
              <Card.Body>
                <Box>
                  <Text as="span" fontSize="highlight">
                    Bienvenido
                  </Text>
                </Box>
              </Card.Body>
            </Card>

            <Card>
              <Card.Header title="Subastas activas" />
              <Card.Body>
                {loadingAuctions ? (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    padding="4"
                  >
                    <Spinner size="large" />
                    <Text fontSize="caption">Cargando subastas...</Text>
                  </Box>
                ) : activeAuctions.length > 0 ? (
                  activeAuctions.map((auction) => (
                    <Box
                      key={auction.id}
                      display="grid"
                      gridTemplateColumns="repeat(auto-fit, minmax(200px, 1fr))"
                      gap="2"
                      padding="2"
                      marginBottom="2"
                    >
                      <Text>
                        <strong>Nombre:</strong> {auction.name}
                      </Text>
                      <Text>
                        <strong>Base:</strong> ${auction.priceBase}
                      </Text>
                      <Text>
                        <strong>Ofertas:</strong> {auction.offerCount}
                      </Text>
                      <Text>
                        <strong>Mayor oferta:</strong> ${auction.highestOffer}
                      </Text>
                      <Text>
                        <strong>Finaliza:</strong> {auction.endDate}
                      </Text>
                      <Text>
                        <strong>Restante:</strong> {auction.timeRemaining}
                      </Text>
                    </Box>
                  ))
                ) : (
                  <Text as="p" fontSize="highlight" color="success-interactive">
                    <strong>No hay subastas activas</strong>
                  </Text>
                )}
              </Card.Body>
            </Card>
          </Layout.Section>
        </Layout>
      </Page.Body>
    </Page>
  );
};

export default PageDashboard;
